import './styles/app.css'
import 'vuetify/styles'
import { useCurrentUserStore } from './stores/currentUserStore'
export const app = {
  mounted () {
    this.$nextTick(() => {
      // add cookie bar here
    })
  },
  components: {

  },
  data () {
    return {
      menu: false
    }
  },
  methods: {
    toggleMainMenu () {
      this.menu = !this.menu
    }
  },
  created () {
    const store = useCurrentUserStore()
    const userElement = document.querySelector('[data-user]')
    // get data-user from element and save to user
    const user = userElement?.getAttribute('data-user')
    if (user) {
      store.loadFromJson(JSON.parse(user))
    }
  }
}
